import { Component, DestroyRef, inject, Input, ViewChild } from '@angular/core';
import { MdbPopoverDirective, MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { PopoverService } from 'app/core/services/popover.service';
import { PeerToPeerManageService } from 'app/manage-p2p/services/peer-to-peer-manage/peer-to-peer-manage.service';
import { Store, select } from '@ngrx/store';
import { selectFundraiserReport, selectP2PCampaignsList } from 'app/manage-p2p/features/p2p.selectors';
import { combineLatest, filter } from 'rxjs';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

let id = 1;

@Component({
  standalone:true,
  selector: 'app-p2p-items-filter-popover',
  templateUrl: './p2p-items-filter-popover.component.html',
  styleUrl: './p2p-items-filter-popover.component.scss',
  imports:[MdbPopoverModule,CommonModule]
})
export class P2pItemsFilterPopoverComponent {
  destroyRef = inject(DestroyRef)
  @ViewChild('popover') popover: MdbPopoverDirective = null;

  @Input() p2pId = '';

  public teams = [];
  public activeItem = 0

  public fundraiserReport$: any = this.store.pipe(
    select(selectFundraiserReport)
  );

  public p2PCampaigns$: any = this.store.pipe(
    select(selectP2PCampaignsList)
  );

  private _id = id++;
  get id() {
    return `P2pPopoverFilter_${this._id}`;
  }
  
  constructor(
    private popoverService: PopoverService,
    public peerToPeerManageService: PeerToPeerManageService,
    private store: Store
  ) { }

  ngOnInit(): void {
    combineLatest({
      p2pReport: this.fundraiserReport$,
      p2PCampaigns: this.p2PCampaigns$
    }).pipe(
      filter(({p2PCampaigns}: any) => p2PCampaigns.length > 0),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(({p2pReport, p2PCampaigns}) => {
      const currentP2P = p2PCampaigns.filter((campaign) => campaign.id === this.p2pId)[0];;

      this.peerToPeerManageService.p2pReport = p2pReport;
      this.peerToPeerManageService.filterP2pItems()

      this.teams = currentP2P.campaignTypeData.teams || [];
      this.teams.forEach((team) => {
        team.fundraiserCount = this.peerToPeerManageService.p2pReport.filter(donor => donor.teamId == team.id).length;
      })
    });
  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  onCategoryClick(category, activeIdx){
    this.activeItem = activeIdx;
    this.peerToPeerManageService.filterButtonText = category;

    this.peerToPeerManageService.category = category;
    this.peerToPeerManageService.filterP2pItems();
  }

  onTeamClick(team, activeIdx){
    this.activeItem = activeIdx;
    this.peerToPeerManageService.filterButtonText = team.name;

    this.peerToPeerManageService.category = team.id;
    this.peerToPeerManageService.filterP2pItems();
  }
}
